import Vue from 'vue'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import SignUp from '../views/SignUp.vue'
import SignIn from '../views/SignIn.vue'
import SignInPhone from '../views/SignInPhone.vue'
import SignUpPhone from '../views/SignUpPhone.vue'
import ActionLink from '../views/ActionLink.vue'

import store from '../store'
import { Position } from 'vue-router/types/router'

Vue.use(VueRouter)

const routes: RouteConfig[] = [
	{
		path: '/',
		name: 'home',
		components: {
      public: Home,
    },
		meta: {
			description: '',
		}
	},
	{
		path: '/signin',
		name: 'signIn',
		components:{public: SignIn},
		meta: {
			description: '',
		}
	},
  {
		path: '/signin/email',
		name: 'signInWithEmail',
    components: {public: () => import('../views/SignInEmail.vue')},
		meta: {
		}
  },
  {
		path: '/signin/phone',
		name: 'signInWithPhone',
    components:{public: SignInPhone},
		meta: {
		}
  },
	{
		path: '/signup',
		name: 'signUp',
		components:{public: SignUp},
		meta: {
		}
  },
  {
		path: '/signup/email',
		name: 'signUpWithEmail',
    components:{public: () => import('../views/SignUpEmail.vue')},
		meta: {
		}
  },
  {
		path: '/signup/phone',
		name: 'signUpWithPhone',
    components: {public: SignUpPhone},
		meta: {
		}
  },
  {
		path: '/actionlink',
		name: 'actionLink',
		components:{public: ActionLink},
		meta: {
		}
  },
  {
		path: '/introduction',
		name: 'introduction',
		components: {signedUp: () => import('../views/Introduction.vue')},
		meta: {
			accessLevel: {
        owner: false,
        admin: false,
        staff: false,
        teacher: false,
        parent: false,
        chid: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/account',
		name: 'account',
		components:{
      default: () => import('../views/Account.vue'),
      noSchool: () => import('../views/Account.vue'),
    },
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
  {
		path: '/admin/delete-school',
		name: 'deleteSchool',
		component: () => import('../views/admin/DeleteSchool.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: false,
        staff: false,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/delete-account',
		name: 'deleteAccount',
		components:{
      default: () => import('../views/DeleteAccount.vue'),
      invited:  () => import('../views/DeleteAccount.vue'),
      noSchool:  () => import('../views/DeleteAccount.vue'),
    },
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
  {
		path: '/enter-school',
		name: 'enterSchool',
		components: {
      invited: () => import('../views/EnterSchool.vue'),
      default: () => import('../views/EnterSchool.vue'),
      noSchool:  () => import('../views/EnterSchool.vue'),
    },
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
  {
		path: '/select-school',
		name: 'selectSchool',
		component: () => import('../views/SelectSchool.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
  {
		path: '/user/dashboard',
		name: 'dashboard',
		component: () => import('../views/user/Dashboard.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
  /*
  {
		path: '/user/scheduling',
		name: 'scheduling',
		component: () => import('../views/user/Scheduling.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
  */
  {
		path: '/user/class',
		name: 'yourClass',
		component: () => import('../views/user/Class.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true,
      }
		}
  },
  {
		path: '/user/group',
		name: 'yourGroup',
		component: () => import('../views/user/Group.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
	{
		path: '/user/profile',
		name: 'profile',
		component: () => import('../views/user/Profile.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
  {
		path: '/user/preferences',
		name: 'userPreferences',
		component: () => import('../views/user/UserPreferences.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
  {
		path: '/change-email',
		name: 'changeEmail',
		components:{
      default: () => import('../views/ChangeEmail.vue'),
      noSchool: () => import('../views/ChangeEmail.vue'),
    },
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
  {
		path: '/user/schedule',
		name: 'schedule',
		component: () => import('../views/user/Schedule.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
  {
    path: '/user/schedule/:eventId',
    redirect: (to) => {
      const {params} = to
      return {
        name: 'schedule',
        query: {eventId: params.eventId || ''}
      }
    }
  },
  {
		path: '/user/schedule-settings',
		name: 'scheduleSettings',
		component: () => import('../views/user/ScheduleSettings.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
  {
		path: '/change-phone-number',
		name: 'changePhoneNumber',
		components:{
      default: () => import('../views/ChangePhoneNumber.vue'),
      noSchool: () => import('../views/ChangePhoneNumber.vue'),
    },
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
	},
	{
		path: '/admin/userlist',
		name: 'userList',
		component: () => import('../views/admin/UserList.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
	},
	{
		path: '/admin/add-user',
		name: 'addUser',
		component: () => import('../views/admin/AddUser.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/classlist',
		name: 'classList',
		component: () => import('../views/admin/ClassList.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/add-class',
		name: 'addClass',
		component: () => import('../views/admin/AddClass.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/edit-class/:classId',
		name: 'editClass',
		component: () => import('../views/admin/EditClass.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/grouplist',
		name: 'groupList',
		component: () => import('../views/admin/GroupList.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/add-group',
		name: 'addGroup',
		component: () => import('../views/admin/AddGroup.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/edit-group/:groupId',
		name: 'editGroup',
		component: () => import('../views/admin/EditGroup.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
	{
		path: '/admin/edit-user/:userId',
		name: 'editUser',
		component: () => import('../views/admin/EditUser.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/edit-relationship/:userId',
		name: 'editUserRelationship',
		component: () => import('../views/admin/EditUserRelationship.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/edit-notification-settings/:userId',
		name: 'editUserNotificationSettings',
		component: () => import('../views/admin/EditUserNotificationSettings.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/edit-user-settings/:userId',
		name: 'editUserSettings',
		component: () => import('../views/admin/EditUserSettings.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/settings',
		name: 'settings',
		component: () => import('../views/admin/Settings.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: false,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/linelink-settings',
		name: 'lineLinkSettings',
		component: () => import('../views/admin/LineLinkSettings.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: false,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/add-school',
		name: 'addSchool',
		components:{
      default: () => import('../views/AddSchool.vue'),
      noSchool: () => import('../views/AddSchool.vue'),
    },
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: true,
        parent: true,
        student: true,
        trainee: true,
        guest: true
      }
		}
  },
  {
		path: '/admin/scheduler',
		name: 'scheduler',
		component: () => import('../views/admin/Scheduler.vue'),
		meta: {
			accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
	},
  {
		path: '/admin/scheduler-settings',
		name: 'schedulerSettings',
		component: () => import('../views/admin/SchedulerSettings.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: false,
        staff: false,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/scheduling-list',
		name: 'schedulingList',
		component: () => import('../views/admin/SchedulingList.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
    path: '/admin/scheduling-list/:schedulingId',
    redirect: (to) => {
      const { params } = to
      return {
        name: 'schedulingList',
        query: {schedulingId: params.schedulingId || ''}
      }
    }
  },
  {
		path: '/admin/add-scheduling',
		name: 'addScheduling',
		component: () => import('../views/admin/AddScheduling.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  {
		path: '/admin/edit-scheduling/:schedulingId',
		name: 'editScheduling',
		component: () => import('../views/admin/EditScheduling.vue'),
		meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
		}
  },
  // Tasks page
  /**
   * accessLevel: owner,admin,staff,teacher
   */
  {
    path: '/admin/playground-list',
    name: 'playgroundList',
    component: () => import('../views/admin/PlaygroundList.vue'),
    meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
    }
  },
  {
    path: '/admin/playground/:playgroundId',
    name: 'playground',
    component: () => import('../views/admin/PlaygroundPlaying.vue'),
    meta: {
      accessLevel: {
        owner: true,
        admin: true,
        staff: true,
        teacher: false,
        parent: false,
        student: false,
        trainee: false,
        guest: false
      }
    }
  },
  {
		path: '*',
		name: 'notFound',
		component: undefined,
		meta: {
		}
	}
]

// eslint-disable-next-line
const scrollBehavior = (to: Route, from: Route, savedPosition: void | Position) => {
  if (to.hash) {
    return {
      selector: to.hash
      // , offset: { x: 0, y: 10 }
    }
  }
}

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
  routes,
  scrollBehavior,
  linkExactActiveClass: 'is-active exact-active',
  linkActiveClass: 'is-active'
})

router.beforeEach((to, from, next) => {
	console.log('beforeEach')
  //console.log(store.getters.schoolId)
  if(to.name === 'welcome' && store.getters.schoolId){
    //初期設定が終わっていたら行かせない
    next({ name: 'dashboard'})//最終的にダッシュボードへ変える
    return
  }
  
  if(to.name !== 'actionLink' && to.query && to.query.mode){
    next({ name: 'actionLink', query: to.query })
    return
  }

  next()
})

router.afterEach(() => {
	console.log('afterEach')
})

export default router
